// mixin for the pizza customize page

import * as ingredientUtils from '../../utils/ingredients'
import { mapGetters, mapActions } from 'vuex'
import image from '../products/image'
import { ingredientLimit } from '../../utils/const.js'

export default {
  mixins: [image],
  data () {
    return {
      currentSelection: {},
      previousSelection: {},
      selectedBase: null,
      selectedSize: null,
      selectionDisabled: false,
      selectedIngredientId: false
    }
  },
  computed: {
    ...mapGetters([
      'ingredientGroups',
      'bases',
      'toppings',
      'activeProduct',
      'toppingList',
      'parentProduct',
      'currentItem',
      'currentStore',
      'activeChild'
    ]),
    availableBases() {
      if (Array.isArray(this.activeProduct.available_ingredients) && this.activeProduct.available_ingredients.length) {
        const bases = this.bases.filter(item => this.activeProduct.available_ingredients.includes(item.id))
        if (bases.length === 0) {
          if (this.selectedSize) {
            return this.bases.filter(base => !!base.sizes.find(size => size.size === this.selectedSize))
          }
          return this.bases
        }
        if (this.selectedSize) {
          return bases.filter(base => !!base.sizes.find(size => size.size === this.selectedSize))
        }
        return bases
      } else {
        if (this.selectedSize) {
          return this.bases.filter(base => !!base.sizes.find(size => size.size === this.selectedSize))
        }
        return this.bases
      }
    },
    availableToppings () {
      if (Array.isArray(this.activeProduct.available_ingredients) && this.activeProduct.available_ingredients.length) {
        return JSON.parse(JSON.stringify(this.toppings)).map(group => {
          group.ingredients = group.ingredients.filter(item => this.activeProduct.available_ingredients.includes(item.id))
          group.ingredientIds = group.ingredientIds.filter(id => this.activeProduct.available_ingredients.includes(id))
          return group
        }).filter(group => group.ingredients.length)
      } else {
        return this.toppings
      }
    },
    predefinedIngredientIds () {
      return this.activeProduct.items.map((item) => item.id)
    },
    ingredientList () {
      return Object.entries(this.currentSelection)
        .filter(item => item[1] !== false)
        .map(item => this.toppingList.filter(topping => topping.id === parseInt(item[0])))
        .flat()
        .map(item => item.name).join(', ')
    },
    showSize () {
      return this.activeProduct.showSize !== undefined ? this.activeProduct.showSize : true
    },
    showBase () {
     return this.activeProduct.showBase !== undefined ? this.activeProduct.showBase : true
    },
    parentDescription () {
      if (this.parentProduct) {
        if (this.parentProduct.product_type === 'deal') {
          return this.parentProduct.name + ' ' + this.parentProduct.selectedSize.size
        }
      }
      return false
    },
    noItemIDs () {
      return Object.fromEntries(this.ingredientGroups.filter(group => group.noItem).map(group => [group.slug, group.noItem.id]))
    }
  },
  mounted () {
    setTimeout(() => {
      this.initializePizza()
    }, 10)
  },
  methods: {
    ...mapActions(['setSize', 'setIngredientSelection', 'setBase']),
    setPizzaSize (data) {
      this.setSize(data)
      if (this.$platform === 'app') {
        setTimeout(() => {
          const selectedBase = this.availableBases.find(base => base.id === this.selectedBase)
          if (!selectedBase) {
            if (this.availableBases.length) {
              this.selectedBase = this.availableBases[0].id
              this.setBase(this.availableBases[0])
            }
          }
        }, 0)
      } else {
        const selectedBase = this.availableBases.find(base => base.id === this.selectedBase)
        if (!selectedBase) {
          if (this.availableBases.length) {
            this.selectedBase = this.availableBases[0].id
            this.setBase(this.availableBases[0])
          }
        }
      }
    },
    initializePizza () {
      const setBase = (base) => {
        this.selectedBase = base.id
        this.setBase(base)
      }
      let setupBase = true
      if (this.currentItem.id === -1) {
        setupBase = false
      } else if (this.activeChild.length > 1) {
        let item = JSON.parse(JSON.stringify(this.currentItem))
        let parentItem = null
        if (item.products && item.products.length) {
          for (let i = 0; i < this.activeChild.length; i++) {
            if (i === this.activeChild.length - 2) {
              parentItem = item.products[this.activeChild[i]] ?? item
            } else {
              item = item.products[this.activeChild[i]]
            }
          }
        }
        if (parentItem && parentItem.id === -1) {
          setupBase = false
        }
      }
      if (setupBase) {
        if (this.activeProduct.selectedBase) {
          this.selectedBase = this.activeProduct.selectedBase.id
        } else if (this.bases.length) {
          if (this.activeProduct.default_base) {
            const base = this.bases.filter(base => base.id === parseInt(this.activeProduct.default_base))[0]
            if (base) {
              setBase(base)
            } else {
              setBase(this.bases[0])
            }
          } else {
            setBase(this.bases[0])
          }
        }
      }
      if (this.activeProduct.selectedSize) {
        this.selectedSize = this.activeProduct.selectedSize.size
      } else {
        if (this.$platform !== 'pos' && this.activeProduct.sizes.length) {
          this.selectedSize = this.activeProduct.sizes[0].size
        }
      }
      if (this.activeProduct.product_type === 'pizza') {
        if (this.activeProduct.ingredientSelection) { // it belongs to a parent product
          const selection = Object.assign({}, this.activeProduct.ingredientSelection)
          Object.keys(selection).forEach(id => {
            if (selection[id] < 0)
            selection[id] = false
          })
          const preselected = ingredientUtils.getPreSelectedToppings(this.ingredientGroups, this.activeProduct.items)
          this.currentSelection = Object.assign(preselected, selection)
          this.previousSelection = Object.assign({}, this.currentSelection)
          this.processSelectionResult(ingredientUtils.checkLimits(this.currentSelection, this.previousSelection, this.activeProduct, this.ingredientGroups))
        } else {
          this.currentSelection = ingredientUtils.getPreSelectedToppings(this.ingredientGroups, this.activeProduct.items)
          this.previousSelection = Object.assign({}, this.currentSelection)
        }

        if (ingredientLimit <= Object.values(this.currentSelection).reduce((total, val) => total + (val !== false ? 1 : 0), 0)) {
          this.selectionDisabled = true
        } else {
          this.selectionDisabled = false
        }
      }
    },
    save (e = false) { // emit the event that the pizza has been customized
      this.$emit('product:save', e)
    },
    getBasePrice (base) {
      const size = base.sizes.filter(size => size.size === this.selectedSize)[0]
      if (size) {
        return parseFloat(size.price) !== 0 ? ( '+&pound;' + size.price) : ''
      }
      return ''
    },
    getToppingPrice (prices, qty = 1) {
      let size = prices.filter(size => size.size === this.selectedSize)[0]
      if (size) {
        const half = this.parentProduct.product_type === 'halfNHalf' ? 2 : 1
        return parseFloat(size.price) !== 0 ? ( '+&pound;' + (size.price * qty / half)) : ''
      }
      return ''
    },
    processSelection (ingredient, value) {
      const noItemIDs = Object.values(this.noItemIDs)
      this.selectedIngredientId = ingredient.id
      const result = ingredientUtils.processIngredientSelection(this.ingredientGroups, this.currentSelection, this.previousSelection, ingredient, value, this.activeProduct)
      this.processSelectionResult(result, !noItemIDs.includes(ingredient.id))
    },
    processSelectionResult (result, notify = true) {
      if (result.maximumReached && typeof this.notifyIngredientLimit === 'function') {
        if (notify) {
          this.notifyIngredientLimit('maximum')
        }
      }

      if (result.minimumReached && typeof this.notifyIngredientLimit === 'function') {
        if (notify) {
          this.notifyIngredientLimit('minimum')
        }
      }

      this.selectionDisabled = result.maximumReached
      this.setIngredientSelection(result.selection)

      setTimeout(() => {
        Object.keys(result.selection).forEach(key => {
          this.currentSelection[key] = result.selection[key]
          this.previousSelection[key] = result.selection[key]
        })
      }, 1)
    },
    checkDisabled (topping, column = 1) {
      if (column === 1) {
        const selectionIds = Object.entries(this.currentSelection).filter(item => item[1] !== false).map(item => parseInt(item[0]))
        if (selectionIds.includes(this.noItemIDs[topping.tags[0]])) {
            return false
          }
          return !topping.slug.includes('no-') && this.selectionDisabled && this.currentSelection[topping.id] !== (topping.slug.includes('no-') ? 0 : 1)
      }

      return this.selectionDisabled && this.currentSelection[topping.id] !== 2
    }
  }
}
